<template>
    <div class="container">
      <div class="row align-items-center justify-content-between">
  
        <div class="col-10 col-lg-10">
          <h3 class="" v-if="summary.length < 1"> Leuk dat je er was! <br><br>Vergeet niet je veiling items mee te nemen / af te rekenen.<br><br> Dit is niet verplicht, maar donaties zijn zeer welkom </h3>
          <table cellpadding="10" style="font-size: 20px;width: 90%" v-if="summary.length">
            <tr>
              <th>&nbsp;</th>
              <th>Bieder</th>
              <th style="text-align: right">Items</th>
              <th style="text-align: right">Prijsindicatie</th>
              <th style="text-align: right">Uitgaven</th>
              <th style="text-align: right">Winst</th>
            </tr>
            <tr v-for="(item, index) in summary">
              <td style="border-bottom: 1px solid #FFFFFF; text-align: center">{{ index + 1 }}</td>
              <td style="border-bottom: 1px solid #FFFFFF; text-align: left">{{ item.name }}</td>
              <td style="border-bottom: 1px solid #FFFFFF; text-align: right">{{ item.items }}</td>
              <td style="border-bottom: 1px solid #FFFFFF; text-align: right">{{ formatPrice(item.indication) }}</td>
              <td style="border-bottom: 1px solid #FFFFFF; text-align: right">{{ formatPrice(item.spend) }}</td>
              <td style="border-bottom: 1px solid #FFFFFF; text-align: right">{{ getProfit(item) }}</td>
            </tr>
          </table>
        </div>
  
      </div>
    </div>
  
  </template>
  
  
  <script>
  
  export default {
    props: {
      summary: {
        type: Object,
        required: true,
      },
    },
    methods: {
      getProfit(item) {
        return parseFloat(item.indication - item.spend).toFixed(2);
      },
      formatPrice(price) {
        if (price == null) {
          return '0.00';
        }
        return parseFloat(price).toFixed(2);
      }
    }
  }
  </script>
  